import { createSlice } from "@reduxjs/toolkit";
import { findDatosEmergenciaByUser } from "../services/datosEmergencia";

const initState = {
  datos: [],
  isLoading: false,
  error: false,
  errorMessage: "",
};

const datosEmergenciaSlice = createSlice({
  name: "datosEmergencia",
  initialState: initState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setDatos: (state, action) => {
      state.datos = action.payload;
    },
  },
});

export const { setDatos, setError, setErrorMessage, setLoading } =
  datosEmergenciaSlice.actions;

export default datosEmergenciaSlice.reducer;

export const fetchDatos = (userID) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(false));
    dispatch(setErrorMessage(""));
    try {
      const response = await findDatosEmergenciaByUser(userID);
      dispatch(setDatos(response));
    } catch (error) {
      dispatch(setError(true));
      dispatch(setErrorMessage(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  };
};
